import React, { useEffect, useState } from "react";
import Edit_MRM from "./edit_MRM/Edit_MRM";
import MRM_Form from "./mrm_Form/MRM_Form";
import MRM_table from "./mrm_table/MRM_table";
import {
  Create,
  GetAll,
} from "../../../../../../../src/features/admin/quality_management/management_system/Slice";
import { useDispatch, useSelector } from "react-redux";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import { FixIDS } from "../../../../../../utils/fixIDS";

function MRM({ managementdetails, setCurrentPage, currentPage }) {
  const dispatch = useDispatch();
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);

  const permissions = useSelector((state) => state.auth.permissions);
  const haveAddPermission = permissions?.includes(FixIDS.mrm.Add);
  const haveReadPermission = permissions?.includes(FixIDS.management_system.List);

  const handleEdit = (id) => {
    setEditId(id);
    setIsEdit(true);
  };
  return (
    <section className="Imperiality">
      {isEdit ? (
        <>
          <div className="back_div">
            {/* <Common_Back_Btn backText="Edit MRM" /> */}
          </div>
          <Edit_MRM
            managementsystemTypeId={2}
            id={editId}
            onCancel={() => {
              setIsEdit(false);
              setEditId(null);
            }}
          />
        </>
      ) : (
        <>
          <div className="imperiality_Form_div">
            {haveAddPermission && <MRM_Form managementsystemTypeId={2} />}
          </div>

          <div className="imperiality_table_div">
            {haveReadPermission && (
              <MRM_table
                managementsystemTypeId={2}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                managementdetails={managementdetails}
                // onEdit={() => setIsEdit(true)}
                onEdit={handleEdit}
              />
            )}
          </div>
        </>
      )}
    </section>
  );
}

export default MRM;
